import React, { PureComponent } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend, Sector, Text } from 'recharts';


const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#DC143C', '#FF69B4', '#808080', '#ADD8E6', '#90EE90', '#9370DB'];

class StatisticsPieChart extends PureComponent {
 type = this.props.type;
 week = this.props.week;

 //We need the isCount variable for setting the labels in the chart.
 isCount;

  labelTypeMap = (type) => {
    switch (type) {
      case 'restaurantOrderTypes':
        return 'Total';
      case 'restaurantProducts':
        return this.isCount ? 'Count' : 'Price';
      case 'restaurantPromotions':
        return this.isCount ? 'Count'  : 'Discount';
      case 'promoCodes':
        return this.isCount ? 'Count' : 'Value';
      default: return null;
    }
  }

  containsDuplicates = serviceData => {
    if (serviceData.length !== new Set(serviceData).size) {
      return true;
    }
    return false;
  }

  formatData = (type, serviceData, week) => {
    let data;
    if(type === 'restaurantProducts') {
      
        //Checking if the array with data contains duplicate values for the totalSpent property. 
        //If yes we take the count (if there are no duplicate values for the count), if not we take the totalSpent.
        const totalSpentArr = serviceData.map(e => e.totalSpent);
        const countArr = serviceData.map(e => e.quantity);
        if ((this.containsDuplicates(countArr) && !this.containsDuplicates(totalSpentArr) ) || (this.containsDuplicates(countArr) && this.containsDuplicates(totalSpentArr))) {
          
          this.isCount = false;
          return data = serviceData.map(item => {
            return {
                  name: item.name,
                  value: item.totalSpent 
                }
          }) 
        } else {
          this.isCount = true;
         return data = serviceData.map(item => {
            return {
                  name: item.name,
                  value: item.quantity 
                } 
          }) 
        }
      } else if(type === 'restaurantPromotions') {
        return data = serviceData.map(item => {
          return {
                name: item.name,
                value: item.discount
              }
        })
      } else if((type === 'promoCodes')) {
        const valueArr = serviceData.map(e => e.totalDiscount);
        const countArr = serviceData.map(e => e.count);
        if(this.containsDuplicates(countArr) && !this.containsDuplicates(valueArr)) {
          return data = serviceData.map(item => {
            this.isCount = false;
            return {
                  name: item.promoCode,
                  value: item.totalDiscount
              }
          }) 
        } else {
          return data = serviceData.map(item => {
            this.isCount = true;
            return {
                  name: item.promoCode,
                  value: item.count
              }
          }) 
        }
      }
    }

    renderActiveShape = (props) => {
      const RADIAN = Math.PI / 180;
      const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
      const sin = Math.sin(-RADIAN * midAngle);
      const cos = Math.cos(-RADIAN * midAngle);
      const sx = cx + (outerRadius + 10) * cos;
      const sy = cy + (outerRadius + 10) * sin;
      const mx = cx + (outerRadius + 20) * cos;
      const my = cy + (outerRadius + 30) * sin;
      const ex = mx + (cos >= 0 ? 1 : -1) * 10;
      const ey = my;
      const textAnchor = cos >= 0 ? 'start' : 'end';
      const index = payload.name.indexOf( ' ', payload.name.indexOf( ' ' ) + 1 )

      return (
        <g> 
          {/* in the next 2 text tags we split the name inside the pie chart by 2nd white space */}
          <text x={cx} y={cy} dy={4} textAnchor="middle" fill={fill} fontSize={12}>
              {index >= 0 ? payload.name.substr( 0, index ) : payload.name.substr( index + 1 )}
          </text>
          <text x={cx} y={cy} dy={16} textAnchor="middle" fill={fill} fontSize={12}>
              {index >= 0 && payload.name.substr( index + 1 )}
          </text>
          {/* <text x={cx} y={cy} dy={4} textAnchor="middle" fill={fill} fontSize={8}>
              {payload.name}
          </text> */}
          <Sector
            cx={cx}
            cy={cy}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            startAngle={startAngle}
            endAngle={endAngle}
            fill={fill}
          />
          <Sector
            cx={cx}
            cy={cy}
            startAngle={startAngle}
            endAngle={endAngle}
            innerRadius={outerRadius + 6}
            outerRadius={outerRadius + 8}
            fill={fill}
          />
          <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
          <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
          <text x={ex + (cos >= 0 ? 1 : -1) * 1} y={ey} textAnchor={textAnchor} fill="#333" fontSize={12}>{`${this.labelTypeMap(this.props.type)} ${this.labelTypeMap(this.props.type) !== "Count" ? value.toFixed(2) : value}`}</text>
          <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999" fontSize={10}>
            {`(Rate ${(percent * 100).toFixed(2)}%)`}
          </text>
        </g>
      );
    };

      state = {
        activeIndex: 0,
      };
    
      onPieEnter = (_, index) => {
        this.setState({
          activeIndex: index,
        });
      };
    
      render() {
        
        return (
          <ResponsiveContainer width="100%" height="66%">
            <PieChart width={400} height={400}>
              <Pie
                activeIndex={this.state.activeIndex}
                activeShape={this.renderActiveShape}
                data={this.formatData(this.props.type, this.props.summary)}
                cx="50%"
                cy="50%"
                innerRadius={80}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                onMouseEnter={this.onPieEnter}
              />
            </PieChart>
          </ResponsiveContainer>
        );
      }
}

export default StatisticsPieChart;


// WEBPACK FOOTER //
// ./src/components/restaurants/restaurantInsight/StatisticsPieChart.js